<div class="card" (click)="clicked.emit()" [class.fixed-height]="fixedHeight" [class.shrunk]="!expanded"
  [class.minify]="minify" [class.alert]="card.alert" [class]="card.type">

  <header class="header">
    <div class="code" *ngIf="expanded && !minify">
      <strong>{{card.code}}</strong>
    </div>

    <div class="board-title" *ngIf="card.boardName && expanded">
      <span>{{ card.boardName }}</span>
    </div>
    
    <h3 class="title" *ngIf="!fixedHeight && expanded && !minify">
      {{ card.name | elipse:60 }}
    </h3>
    <h3 class="title" [class.small]="fixedHeight" *ngIf="fixedHeight && expanded">
      {{ card.name | elipse:30 }}
    </h3>
    
    <span class="code minified" *ngIf="!expanded">{{ card.code }}</span>

    <div class="epic" *ngIf="card.epic && inColumn && !minify && expanded">
      <span>{{ card.epic }}</span>
    </div>

    <div class="labels" *ngIf="card.labels && inColumn && !minify && expanded">
      <span class="label" *ngFor="let item of card.labels">#{{ item }}</span>
    </div>

    <app-avatar *ngIf="card.assignedTo && !minify && expanded" 
                [userKey]="card.assignedTo" 
                class='avatar-top-right'></app-avatar>
  </header>
  
  <main class="body" *ngIf="!fixedHeight && !minify && expanded">
    <div class="message" *ngIf="card.count > 0" [attr.aria-label]="'Messages: ' + card.count">
      {{ card.count }}
    </div>
    
    <div class="card-types">
      <span class="environment" *ngIf="card.environment && expanded && !minify"
            [title]="card.environment">
        {{ envAbbrev(card.environment) }}
      </span>
      <span class="module" *ngIf="card.module && expanded && !minify"
            [title]="card.module">
        {{ envAbbrev(card.module) }}
      </span>
      <span class="part" *ngIf="expanded && card.part && !minify && parts && parts[card.part]"
            [style.background-color]="parts[card.part].color">
        {{ card.part }}
      </span>
      <span class="type" *ngIf="card.type !== 'Task'" [class]="card.type">
        {{ card.type }}
      </span>
    </div>
    
    <div class="details" *ngIf="expanded && !minify">
      <div class="ensues">
        <div class="issues" *ngIf="card.issues > 0" [title]="'Issues: ' + card.issues">
          <mat-icon class="bug-icon" aria-hidden="true">bug_report</mat-icon>
          <span>{{ card.issues }}</span>
        </div>
        <div class="enhancements" *ngIf="card.enhancements > 0" [title]="'Enhancements: ' + card.enhancements">
          <mat-icon class="enhancement-icon" aria-hidden="true">new_releases</mat-icon>
          <span>{{ card.enhancements }}</span>
        </div>
      </div>
    </div>
  </main>
  
  <footer class="footer" *ngIf="card.dueDate && expanded && !minify">
    <app-progress-bar [inColumn]="inColumn" 
                      [lane]="card.laneText" 
                      [priority]="card.priority" 
                      [score]="userScore"
                      [lastDueDateChange]="card.lastDueDateChange | stampToDate" 
                      [dueDate]="card.dueDate | stampToDate"
                      [createdDate]="card.createdAt | stampToDate"></app-progress-bar>
  </footer>
</div>

